import Vue from 'vue'
import 'dayjs/locale/ja';
import dayjs from "dayjs";
dayjs.locale("ja");

import '../sass/variables.scss'

/**
 * Adminシステムで利用するロールの文言を返す.
 * @return { string }
 */
Vue.filter('admin_user_role', role => {
  let user_role = null
  switch (role) {
    case 'admin':
      user_role = '管理者'
      break
    case 'editor':
      user_role = '一般'
      break
  }
  return user_role
})

/**
 * Frontで利用するロールの文言を返す.
 * @return { string }
 */
Vue.filter('user_role', role => {
  let user_role = null
  switch (role) {
    case 'super_user':
      user_role = '法人管理者'
      break
    case 'admin_user':
      user_role = 'テナント管理者'
      break
    case 'plain_user':
      user_role = '一般'
      break
    case 'driver_user':
      user_role = 'ドライバー'
      break
    case 'support_user':
      user_role = 'サポート'
      break
  }
  return user_role
})

/**
 * カンマフォーマット
 */
Vue.filter('comma_format', number => {
  if (!number) return number
  number = Number(number)
  return number.toLocaleString(undefined, { maximumFractionDigits: 20 })
})

/**
 * システム小数点表示フォーマット
 */
Vue.filter('number_format', number => {
  if (!number) return number
  number = Number(number)
  return number.toFixed(3)
})

/**
 * 日付フォーマット
 */
Vue.filter('date_format', function (date, format = "YYYY/MM/DD") {
  if (!date) return date
  return dayjs(date).format(format)
})

/**
 * 日付フォーマット
 */
Vue.filter('from_to_date_format', function (from, to) {
  const from_date = from ? dayjs(from).format('YYYY/MM/DD') : ''
  const to_date = to ? dayjs(to).format('YYYY/MM/DD') : ''
  if (from_date !== '' || to_date !== '') {
    return from_date + '〜' + to_date
  } else {
    return ''
  }
})

/**
 * 時間フォーマット
 */
Vue.filter('from_to_linked_time', function (from, to, range = '-') {
  const from_time = (from == null) ? '' : from
  const to_time = (to == null) ? '' : to
  if (from_time !== '' || to_time !== '') {
    return from_time + range + to_time
  } else {
    return ''
  }
})


Vue.filter('emission_user_person_type_label', value => {
  return value === 'deliverer' ? '引渡担当者' : '登録担当者'
})

/**
 * Unixタイムフォーマット
 */
Vue.filter('unix_datetime_format', number => {
  if (!number) return number
  return dayjs.unix(number).format('YYYY/MM/DD HH:mm')
})

/**
 * Unixタイムフォーマット
 */
Vue.filter('unix_date_format', number => {
  if (!number) return number
  return dayjs.unix(number).format('YYYY/MM/DD')
})

/**
 * 日時フォーマット (moment互換)
 */
Vue.filter('moment_datetime', date => {
  if (!date) return date
  return dayjs(date).format('YYYY/MM/DD HH:mm')
})

/**
 * 画像URL
 */
Vue.filter('load_image_url', url => {
  if (!url) return require('@/assets/images/noimage.png')
  return url
})

/**
 * 文字数を制限して余分があれば省略して末尾...に置換する
 * @param {String} text
 * @param {Number} length
 * @param {String} clamp
 * @returns {String}
 */
Vue.filter('truncate', (text, length, clamp) => {
  text = text || ''
  clamp = clamp || '...'
  length = length || 30

  if (text.length <= length) { return text }
  return text.substring(0, length) + clamp
})

Vue.filter('repeat_setting_label', (value) => {
  let label = null
  switch (value) {
    case 'unuse_repeat':
      label = '無し'
      break
    case 'select_date':
      label = '日付選択'
      break
  }
  return label
})

Vue.filter('task_type_label', (value) => {
  let label = null
  switch (value) {
    case 'collection':
      label = '回'
      break
    case 'destination':
      label = '運'
      break
    case 'description':
      label = 'メ'
      break
  }
  return label
})

/**
 * マニフェスト管理
 * マニフェストの予約登録状態名称を返す.
 * @param {string} status - 状態
 * @return {string}
 */
Vue.filter('manifest_regist_status_label', (status) => {
  let label
  switch (status) {
    case 'registered':
      label = '本登録'
      break
    case 'reserved':
      label = '予約登録'
      break
    default:
      label = ''
  }
  return label
})

/**
 * マニフェスト管理
 * マニフェストの予約登録状態のカラーを返す.
 * @param {string} status - 状態
 * @return {string}
 */
Vue.filter('manifest_regist_status_color', (status) => {
  let color
  switch (status) {
    case 'registered':
      color = 'primary'
      break
    case 'reserved':
      color = 'info'
      break
    default:
      color = ''
  }
  return color
})

/**
 * マニフェスト管理
 * マニフェストの状態名称を返す.
 * @param {string} status - 状態
 * @return {string}
 */
Vue.filter('manifest_condition_status_label', (status) => {
  let label
  switch (status) {
    case 'modifiable':
      label = '修正可能'
      break
    case 'awaiting_approval':
    case 'awaiting_reflection':
    case 'denial_awaiting_reflection':
      label = '承認待ち'
      break
    case 'awaiting_reapplication':
      label = '再申請待ち'
      break
    case 'awaiting_jwnet':
      label = 'JWNET登録待ち'
      break
    case 'cancellation':
      label = 'マニ取消済'
      break
    default:
      label = ''
  }
  return label
})

/**
 * マニフェスト管理 ステータスカラー
 * @param {string} status - 状態
 * @return {string}
 */

Vue.filter('manifest_condition_status_color', (status) => {
  let color = null
  switch (status) {
    case 'modifiable':
      color = 'primary'
      break
    case 'awaiting_approval':
    case 'awaiting_reflection':
    case 'denial_awaiting_reflection':
      color = 'grey darken-3 white--text'
      break
    case 'awaiting_reapplication':
      color = 'error'
      break
    case 'cancellation':
      color = 'error'
      break
  }
  return color
})


/**
 * 受注の状態を返す.
 * @return {string}
 */
Vue.filter('status_to_label', (status) => {
  let label = null
  switch (status) {
    case 'ordered':
      label = '　受注　'
      break
    case 'reserved':
      label = '配車済'
      break
    case 'dispatched':
      label = '配車済'
      break
    case 'collected':
      label = '回収完了'
      break
    case 'transported':
      label = '回収完了'
      break
    case 'completed':
      label = '登録完了'
      break
    case 'canceled':
      label = 'キャンセル'
      break
  }
  return label
})


Vue.filter('status_to_label_without_allocate', (status) => {
  let label = null
  switch (status) {
    case 'ordered':
      label = '　受注　'
      break
    case 'reserved':
      label = '予約済'
      break
    case 'dispatched':
      label = '予約済'
      break
    case 'collected':
      label = '予約済'
      break
    case 'transported':
      label = '予約済'
      break
    case 'completed':
      label = '登録完了'
      break
    case 'canceled':
      label = 'キャンセル'
      break
  }
  return label
})

Vue.filter('status_chip_color', (status) => {
  let color = null
  switch (status) {
    case 'ordered':
      color = 'info'
      break
    case 'dispatched':
      color = 'primary'
      break
    case 'reserved':
      color = 'primary'
      break
    case 'collected':
      color = 'blue-grey darken-1'
      break
    case 'transported':
      color = 'blue-grey darken-1'
      break
    case 'completed':
      color = 'grey darken-3'
      break
    case 'canceled':
      color = 'error'
      break
  }
  return color
})

Vue.filter('status_chip_color_without_allocate', (status) => {
  let color = null
  switch (status) {
    case 'ordered':
      color = 'info'
      break
    case 'dispatched':
      color = 'primary'
      break
    case 'reserved':
      color = 'primary'
      break
    case 'collected':
      color = 'primary'
      break
    case 'transported':
      color = 'primary'
      break
    case 'completed':
      color = 'grey darken-3'
      break
    case 'canceled':
      color = 'error'
      break
  }
  return color
})


Vue.filter('notification_type_to_label', (notification_type) => {
  let label = null
  switch (notification_type) {
    case 'jwnet_notification':
      label = 'JWNET'
      break
    case 'dxe_notification':
      label = 'DXEStation'
      break
  }
  return label
})

Vue.filter('notification_type_chip_color', (notification_type) => {
  let color = null
  switch (notification_type) {
    case 'jwnet_notification':
      color = 'red lighten-3'
      break
    case 'dxe_notification':
      color = 'green lighten-3'
      break
  }
  return color
})

Vue.filter('manifest_type_to_label', (manifest_type) => {
  let label
  switch (manifest_type) {
    case 'dxe_form':
    case 0:
      label = '電子マニフェスト(EDI)'
      break
    case 'transfer_form':
    case 3:
      label = "電子マニフェスト(取込)"
      break
    case 'paper_form':
    case 2:
      label = '紙マニフェスト'
      break
    case 'other_form':
    case 1:
      label = '電子マニフェスト(WEB)'
      break
    case "general_form":
    case 4:
      label = "一般廃棄物"
      break
    case 'unneeded':
    default:
      label = 'なし'
  }
  return label
})

/**
 * 登録パターンで利用する登録種別ラベル
 */
Vue.filter("short_order_type_label", (order_type) => {
  let baseLabel = '産廃回収'
  if (order_type === 'self_emission') {
    baseLabel = '排出持込'
  } else if (order_type === 'proxy_request') {
    baseLabel = '他社運搬'
  } else if (order_type === 'general') {
    baseLabel = '一廃回収'
  }
  return baseLabel;
});

Vue.filter('short_manifest_type_label', (manifest_type) => {
  let label
  switch (manifest_type) {
    case 'dxe_form':
      label = 'EDI'
      break
    case 'transfer_form':
      label = "取込"
      break
    case 'paper_form':
      label = '紙'
      break
    case 'other_form':
      label = 'WEB'
      break
    case "general_form":
      label = "一廃"
      break
    case 'unneeded':
    default:
      label = '-'
  }
  return label
})


Vue.filter('manifest_type_to_label_light', (manifest_type) => {
  let label
  switch (manifest_type) {
    case 'dxe_form':
      label = '(EDI)'
      break
    case 'transfer_form':
      label = "(取込)"
      break
    case 'paper_form':
      label = '(紙)'
      break
    case 'other_form':
      label = '(WEB)'
      break
    case 'unneeded':
    default:
      label = 'なし'
  }
  return label
})

Vue.filter('approval_type_to_label', (approval_type, manifest_type) => {
  let label
  if (manifest_type === 'dxe_form') {
    switch (approval_type) {
      case 'none_use_approval':
        label = '利用しない'
        break
      case 'use_approval':
        label = '利用する'
        break
      case 'unneeded':
      default:
        label = 'なし'
    }
  } else {
    label = ''
  }
  return label
})

Vue.filter('subscriber_type_to_label', (subscriber_type) => {
  let label
  switch (subscriber_type) {
    case 'transport_type':
      label = '収集運搬業者'
      break
    case 'disposer_type':
      label = '処分業者'
      break
    default:
      label = 'なし'
  }
  return label
})



/**
 * Adminシステムで利用するJWNET利用料金の文言を返す.
 * @return { string }
 * # a_plan: A料金, b_plan: B料金, c_plan: C料金, none_plan: 不明, c_plan_dxe: C料金(DXE), canceled_c_plan_dxe: 解約(C料金(DXE))
 */
Vue.filter('jwnet_price_plan', plan => {
  let price_plan
  switch (plan) {
    case 'a_plan':
      price_plan = 'A料金'
      break
    case 'b_plan':
      price_plan = 'B料金'
      break
    case 'c_plan':
      price_plan = 'C料金'
      break
    case 'none_plan':
      price_plan = '不明'
      break
    case 'c_plan_dxe':
      price_plan = 'C料金(DXE)'
      break
    case 'canceled_c_plan_dxe':
      price_plan = '解約(C料金(DXE))'
      break
    default:
      price_plan = 'c_plan'
  }
  return price_plan
})

/**
 * Adminシステムで利用する登録料請求先の文言を返す.
 * @return { string }
 * emission: 排出事業者, transport: 収集運搬業者
 */
Vue.filter('registration_fee_type', type => {
  let name
  switch (type) {
    case 'emission':
      name = '排出事業者'
      break
    case 'transport':
      name = '収集運搬業者'
      break
    default:
      name = '排出事業者'
  }
  return name
})

/**
 * EDI申込みステータスの文言を返す.
 * @return { string }
 */
Vue.filter('edi_status_label', status => {
  let label = null
  switch (status) {
    case 'none_request':
      label = '-'
      break
    case 'mail_send':
      label = 'メール送信済'
      break
    case 'mail_bounce':
      label = 'メール送信エラー'
      break
    case 'emission_requested':
      label = '排出申込済'
      break
    case 'jwnet_requested':
      label = 'JWNET登録中'
      break
    case 'edi_available':
      label = 'EDI利用可能'
      break
    case 'edi_completed':
      label = 'EDI登録完了'
      break
    default:
      label = '-'
  }
  return label
})

/**
 * JWNET料金区分の文言を返す.
 * @return { string }
 */
Vue.filter('jwnet_pricing_type_label', type => {
  let label = null
  switch (type) {
    case 'a_plan':
    case 0:
      label = 'A料金'
      break
    case 'b_plan':
    case 1:
      label = 'B料金'
      break
    case 'c_plan':
    case 2:
      label = 'C料金'
      break
    case 'none_plan':
    case 3:
      label = '不明'
      break
    case 'c_plan_dxe':
    case 4:
      label = 'C料金(DXE)'
      break
    default:
      label = '-'
  }
  return label
})


Vue.filter('simple_status_to_label_order', (status) => {
  let label = null
  if (status.match(/^collection/)) {
    label = '産廃回収'
  } else if (status.match(/^pickup/)) {
    label = '積替運搬'
  } else if (status.match(/^carry/)) {
    label = '搬入予約'
  }
  return label
})

/**
 * ダッシュボードの状態を返す.
 * @return {string}
 */
Vue.filter( 'dashboard_status_color', (status, type_acceptance = null, order_type = null) => {
  let color = null

  if (type_acceptance === 1) {
    return 'orange darken-2 white--text'
  }
  switch (status) {
    case 'collection_requested': // 0
    case 'collection_accepted': // 1
    case 'collection_allocated': // 2
    case 'collection_reserved': // 3
    case 'collection_transported': // 4
      if (order_type === 'self_emission') {
        color = 'info'
      } else {
        color = 'primary'
      }
      break
    case 'pickup_requested': // 10
    case 'pickup_accepted': // 11
    case 'pickup_allocated': // 12
    case 'pickup_transported': // 13
      color = 'green darken-2 white--text'
      break
    case 'carry_in_contacted': // 20
    case 'carry_in_accepted': // 21
    case 'carry_allocated': // 22
    case 'carry_transported': // 23
      color = 'orange darken-2 white--text'
      break
  }
  return color
})


/**
 * ダッシュボードの状態を返す.
 * @return {string}
 */
Vue.filter( 'dashboard_status_to_label', (status, type_acceptance = 0, order_type = null) => {
  let label = null

  if (type_acceptance === 1) {
    return '受入予定'
  }

  // 0: collection_requested: 産廃回収 産廃回収（未受付）
  // 1: collection_accepted: 産廃回収（受注）
  // 2: collection_allocated: 産廃回収（配車済）
  // 3: collection_reserved: 産廃回収（予約完了）
  // 4: collection_transported: 産廃回収（回収完了）
  // 5: collection_completed: 産廃回収（登録完了）
  // 6: collection_canceled: 産廃回収（キャンセル）
  //
  // 10: pickup_requested: 積替運搬（未受付）
  // 11: pickup_accepted: 積替運搬（受注）
  // 12: pickup_allocated: 積替運搬（配車済）
  // 13: pickup_transported: 積替運搬（回収完了）
  // 14: pickup_completed: 積替運搬（登録完了）
  // 15: pickup_canceled: 積替運搬（キャンセル）
  //
  // 20: carry_in_contacted: 搬入予約（未受付）
  // 21: carry_in_accepted: 搬入予約（受注)
  // 22: carry_allocated: 搬入予約（配車済）
  // 23: carry_transported: 搬入予約（回収完了）
  // 24: carry_completed: 搬入予約（登録完了）
  // 25: carry_canceled: 搬入予約（キャンセル）

  // order_typeに応じたラベルを決定
  let baseLabel = '産廃回収'
  if (order_type === 'self_emission') {
    baseLabel = '排出持込'
  } else if (order_type === 'proxy_request') {
    baseLabel = '他社運搬'
  } else if (order_type === 'general') {
    baseLabel = '一廃回収'
  }

  switch (status) {
    case 'collection_requested': // 0
      label = `${baseLabel}（未受付）`
      break
    case 'collection_accepted': // 1
      label = `${baseLabel}（受注）`
      break
    case 'collection_allocated': // 2
      label ='産廃回収（配車済）'
      break
    case 'collection_reserved': // 3
      // if (order_type === 'self_emission') {
      //   label = `排出持込（予約完了）`
      // } else {
      //   label ='産廃回収（回収完了）'
      // }
      label = `${baseLabel}（予約完了）`
      break
    case 'collection_transported': // 4
      // label = '産廃回収（回収完了）'
      label = `${baseLabel}（回収完了）`
      break
    case 'pickup_requested': // 10
      label = '積替運搬（未受付）'
      break
    case 'pickup_accepted': // 11
      label = '積替運搬（受注）'
      break
    case 'pickup_allocated': // 12
      label = '積替運搬（配車済）'
      break
    case 'pickup_transported': // 13
      label = '積替運搬（回収完了）'
      break
    case 'carry_in_contacted': // 20
      label = '搬入予約（未受付）'
      break
    case 'carry_in_accepted': // 21
      label = '搬入予約（受付)'
      break
    case 'carry_allocated': // 22
      label = '搬入予約（配車済)'
      break
    case 'carry_transported': // 23
      label = '搬入予約（回収完了)'
      break
  }

  return label
})

/**
 * 受注の状態を返す.
 * @param {string} status - ステータス
 * @param {string} order_type - オーダー種別
 * @return {string}
 */
Vue.filter('status_to_label_accept', (status, order_type = null, enable_allocate = true) => {
  let label = null
  //  *  ordersテーブルのstatus一覧
  // # collection_requested: 産廃回収（未受付）
  // # collection_accepted: 産廃回収（受注）
  // # collection_allocated: 産廃回収（配車済）
  // # collection_reserved: 産廃回収（予約完了）
  // # collection_transported: 産廃回収（回収完了）
  // # collection_completed: 産廃回収（登録完了）
  // # collection_canceled: 産廃回収（キャンセル）
  // #
  // # pickup_requested: 積替運搬（未受付）
  // # pickup_accepted: 積替運搬（受注）
  // # pickup_allocated: 積替運搬（配車済）
  // # pickup_transported: 積替運搬（回収完了）
  // # pickup_completed: 積替運搬（登録完了）
  // # pickup_canceled: 積替運搬（キャンセル）
  // #
  // # carry_in_contacted: 搬入予約（未受付）
  // # carry_in_accepted: 搬入予約（受注)
  // # carry_allocated: 搬入予約（配車済）
  // # carry_transported: 搬入予約（回収完了）
  // # carry_completed: 搬入予約（登録完了）
  // # carry_canceled: 搬入予約（キャンセル）

  // order_typeに応じたラベルを決定
  let baseLabel = '産廃回収'
  if (order_type === 'self_emission') {
    baseLabel = '排出持込'
  } else if (order_type === 'proxy_request') {
    baseLabel = '他社運搬'
  } else if (order_type === 'general') {
    baseLabel = '一廃回収'
  }

  switch (status) {
    case 'collection_requested':
      label = `${baseLabel}（未受付）`
      break
    case 'collection_accepted':
      label = `${baseLabel}（受注）`
      break
    case 'collection_allocated':
      label = enable_allocate ? '産廃回収（配車済）' : `${baseLabel}（受注）`
      break
    case 'collection_reserved':
      label = `${baseLabel}（予約済）`
      break
    case 'collection_transported':
      label = enable_allocate ? '産廃回収（回収完了）' : `${baseLabel}（受注）`
      break
    case 'collection_completed':
      label = `${baseLabel}（登録完了）`
      break
    case 'collection_canceled':
      label = `${baseLabel}（キャンセル）`
      break
    case 'pickup_requested':
      label = '積替運搬（未受付）'
      break
    case 'pickup_accepted':
      label = '積替運搬（受注）'
      break
    case 'pickup_allocated':
      label = enable_allocate ? '積替運搬（配車済）' : '積替運搬（受注）'
      break
    case 'pickup_transported':
      label = enable_allocate ? '積替運搬（回収完了）' : '積替運搬（受注）'
      break
    case 'pickup_completed':
      label = '積替運搬（登録完了）'
      break
    case 'pickup_canceled':
      label = '積替運搬（キャンセル）'
      break
    case 'carry_in_contacted':
      label = '搬入予約（未受付）'
      break
    case 'carry_in_accepted':
      label = '搬入予約（受注)'
      break
    case 'carry_allocated':
      label = '搬入予約（受注)'
      break
    case 'carry_transported':
      label = '搬入予約（受注)'
      break
    case 'carry_completed':
      label = '搬入予約（受注)'
      break
    case 'carry_canceled':
      label = '搬入予約（キャンセル）'
      break
  }
  return label
})

/**
 * 発注の状態を返す.
 * @return {string}
 */
Vue.filter('status_to_label_order_request', (status, temporarily = false) => {
  let label = null
  //  *  ordersテーブルのstatus一覧
  //  *  積替運搬: pickup_requested
  //  *  積替運搬（受付）: pickup_accepted
  //  *  積替運搬（受付）: pickup_allocated
  //  *  積替運搬（受付）: pickup_transported
  //  *  積替運搬（受付）: pickup_completed
  //  *  積替運搬（キャンセル）: pickup_canceled
  //
  //  *  搬入予約: carry_in_contacted
  //  *  搬入予約（受注): carry_in_accepted
  //  *  搬入予約（配車済): carry_allocated
  //  *  搬入予約（回収完了）: carry_transported
  //  *  搬入予約（登録完了: carry_completed
  //  *  搬入予約（キャンセル）: carry_canceled
  switch (status) {
    case 'pickup_requested':
      label = '積替運搬（発注）'
      break
    case 'pickup_accepted':
      label = '積替運搬（受付）'
      break
    case 'pickup_allocated':
      label = '積替運搬（受付）'
      break
    case 'pickup_transported':
      label = '積替運搬（受付）'
      break
    case 'pickup_completed':
      label = '積替運搬（受付）'
      break
    case 'pickup_canceled':
      label = '積替運搬（キャンセル）'
      break
    case 'carry_in_contacted':
      label = '搬入予約（発注）'
      break
    case 'carry_in_accepted':
      label = '搬入予約（受付）'
      break
    case 'carry_allocated':
      label = '搬入予約（配車済)'
      break
    case 'carry_transported':
      label = '搬入予約（回収完了)'
      break
    case 'carry_completed':
      label = '搬入予約（登録完了)'
      break
    case 'carry_canceled':
      label = '搬入予約（キャンセル）'
      break
  }
  if (temporarily) {
    label = `${label}（仮保存）`
  }
  return label
})

/**
 *
 * 受注で利用するステータスの背景色を返します.
 *
 *  ordersテーブルのstatus一覧
 *   # collection_requested: 産廃回収
 *   # collection_accepted: 産廃回収（受注）
 *   # collection_allocated: 産廃回収（配車済）
 *   # collection_reserved: 産廃回収（予約完了）
 *   # collection_transported: 産廃回収（回収完了）
 *   # collection_completed: 産廃回収（登録完了）
 *   # collection_canceled: 産廃回収（キャンセル）
 *   #
 *   # pickup_requested: 積替運搬
 *   # pickup_accepted: 積替運搬（受注）
 *   # pickup_allocated: 積替運搬（配車済）
 *   # pickup_transported: 積替運搬（回収完了）
 *   # pickup_completed: 積替運搬（登録完了）
 *   # pickup_canceled: 積替運搬（キャンセル）
 *   #
 *   # carry_in_contacted: 搬入予約
 *   # carry_in_accepted: 搬入予約（受注)
 *   # carry_allocated: 搬入予約（配車済）
 *   # carry_transported: 搬入予約（回収完了）
 *   # carry_completed: 搬入予約（登録完了）
 *   # carry_canceled: 搬入予約（キャンセル）
 * @return { String }
 */
Vue.filter('status_chip_order_color', (status, order_type = null) => {
  let color = null
  switch (status) {
    // 産廃回収
    case 'collection_requested':
    case 'collection_accepted':
    case 'collection_allocated':
    case 'collection_reserved':
    case 'collection_transported':
      if (order_type === 'self_emission') {
        color = 'info'
      } else {
        color = 'primary'
      }
      break
    // 積替運搬
    case 'pickup_requested':
    case 'pickup_accepted':
    case 'pickup_allocated':
    case 'pickup_transported':
      color = 'green darken-2 white--text'
      break
    // 搬入予約
    case 'carry_in_contacted':
    case 'carry_in_accepted':
    case 'carry_allocated':
    case 'carry_transported':
    case 'carry_completed':
      color = 'orange darken-2 white--text'
      break
    // 登録完了
    case 'collection_completed':
    case 'pickup_completed':
      color = 'grey darken-3 white--text'
      break
    // キャンセル
    case 'collection_canceled':
    case 'pickup_canceled':
    case 'carry_canceled':
      color = 'error'
      break
  }
  return color
})

/**
 *
 * 受注・マニフェスト詳細画面で利用する排出承認_承認状況の名称を返します.
 *
 * @return { String }
 */
 Vue.filter('approval_status_chip_label', (approval_status, manifest_registered) => {
  let label = ''
  switch (approval_status) {
    // 差戻
    case 'remand':
      label = '差戻'
      break
    // 承認（本登録済）：青
    // 承認（本登録前）：赤
    case 'approved':
      if (manifest_registered) {
        label = '承認（本登録済）'
      } else {
        label = '承認（本登録前）'
      }
      break
    // 予約登録前、メール送信対象、メール送信前、排出承認待ち：黄色
    case 'before_reserve':
    case 'send_target':
    case 'await_approval':
      label = '未承認'
      break
  }
  return label
})

/**
 *
 * 受注・マニフェスト詳細画面で利用する排出承認_承認状況の背景色を返します.
 *
 * @return { String }
 */
Vue.filter('approval_status_chip_color', (approval_status, manifest_registered) => {
  let color = null
  switch (approval_status) {
    // 差戻
    case 'remand':
      color = 'red darken-2 white--text'
      break
    // 承認（本登録済）：青
    // 承認（本登録前）：オレンジ
    case 'approved':
      if (manifest_registered) {
        color = 'primary darken-2 white--text'
      } else {
        color = 'orange darken-2 white--text'
      }
      break
    // 予約登録前、メール送信対象、メール送信前、排出承認待ち：黄色
    case 'before_reserve':
    case 'send_target':
    case 'await_approval':
      color = 'yellow darken-2 white--text'
      break
  }
  return color
})

/**
 *
 * 発注で利用するステータスの背景色を返します.
 *
 *  ordersテーブルのstatus一覧
 *  積替運搬: pickup_requested
 *  積替運搬（受付）: pickup_accepted
 *  積替運搬（受付）: pickup_allocated
 *  積替運搬（受付）: pickup_transported
 *  積替運搬（受付）: pickup_completed
 *  積替運搬（キャンセル）: pickup_canceled
 *
 *  搬入予約: carry_in_contacted
 *  搬入予約（受注): carry_in_accepted
 *  搬入予約（配車済): carry_allocated
 *  搬入予約（回収完了）: carry_transported
 *  搬入予約（登録完了: carry_completed
 *  搬入予約（キャンセル）: carry_canceled
 * @return { String }
 */
Vue.filter('status_chip_requests_color', (status) => {
  let color = null
  switch (status) {
    // 積替運搬
    case 'pickup_requested':
    case 'pickup_accepted':
    case 'pickup_allocated':
    case 'pickup_transported':
    case 'pickup_completed':
      color = 'green darken-2 white--text'
      break
    // 搬入予約
    case 'carry_in_contacted':
    case 'carry_in_accepted':
    case 'carry_allocated':
    case 'carry_transported':
      color = 'orange darken-2 white--text'
      break
    // 登録完了
    case 'carry_completed':
      color = 'grey darken-3 white--text'
      break
    // キャンセル
    case 'pickup_canceled':
    case 'carry_canceled':
      color = 'error'
      break
  }
  return color
})

/**
 * 売上管理の状態を返す.
 * @return {string}
 */
Vue.filter('status_to_label_transaction', (status) => {
  let label = null
  switch (status) {
    case 'unregistered':
      label = '売上未登録'
      break
    case 'provisional':
      label = '仮保存'
      break
    case 'registered':
      label = '登録済'
      break
    case 'final_closing':
      label = '本締め'
      break
  }
  return label
})

/**
 * 請求管理の状態を返す.
 * @return {string}
 */
Vue.filter('status_to_label_request', (status) => {
  let label = null
  switch (status) {
    case 'billing_closed':
      label = '本締め'
      break
    case 'billing_confirm':
      label = '仮締め'
      break
    case 'billing_unsettled':
      label = '未締'
      break
  }
  return label
})

// **
//  * freee連携管理の状態を返す.
//  * @return {string}
//  */
Vue.filter('status_to_label_freee_billing_transaction', (status) => {
  let label = null
  switch (status) {
    case 'waiting':
      label = '待機中'
      break
    case 'doing':
      label = '処理中'
      break
    case 'complete':
      label = '完了'
      break
    case 'error':
      label = 'エラー'
      break
  }
  return label
})

/**
 * 取引管理の状態カラーを返す.
 * @return {string}
 */
Vue.filter('status_chip_transaction_color', (status) => {
  let color = null
  switch (status) {
    case 'unregistered':
      color = 'orange darken-2 white--text'
      break
    case 'provisional':
      color = 'grey lighten-4 black--text'
      break
    case 'registered':
      color = 'primary'
      break
    case 'final_closing':
      color = 'grey darken-3'
      break
  }
  return color
})

/**
 * 請求管理の状態カラーを返す.
 * @return {string}
 */
Vue.filter('status_chip_request_color', (status) => {
  let color = null
  switch (status) {
    case 'billing_closed':
      color = 'grey darken-3'
      break
    case 'billing_confirm':
      color = 'primary'
      break
    case 'billing_unsettled':
      color = 'info'
      break
  }
  return color
})

/**
 * 請求管理の状態カラーを返す.
 * @return {string}
 */
Vue.filter('status_chip_freee_billing_transaction_color', (status) => {
  let color = null
  switch (status) {
    case 'waiting':
      color = 'grey darken-3'
      break
    case 'doing':
      color = 'info'
      break
    case 'complete':
      color = 'primary'
      break
    case 'error':
      color = 'error'
      break
  }
  return color
})

Vue.filter('order_edit_label', (status) => {
  let label = null
  switch (status) {
    case 'collection_requested':
      label = '産廃回収からの受注登録'
      break
    case 'tmp_storage':
      label = '編集'
      break
    case 'collection_reception':
      label = '詳細を参照'
      break
    case 'none_collectable':
      label = '詳細を参照'
      break
  }
  return label
})


Vue.filter('order_receive_status_name', type => {
  let name
  switch (type) {
    case 'receive_plan':
      name = '受入予定'
      break
    case 'receive_completed':
      name = '受入完了'
      break
    case 'disposal_completed':
      name = '処分完了'
      break
    case 'receive_canceled':
      name = 'キャンセル'
      break
    default:
      name = ''
  }
  return name
})

Vue.filter('order_receive_status_chip_color', type => {
  let name
  switch (type) {
    case 'receive_plan':
      name = 'orange darken-2 white--text'
      break
    case 'receive_completed':
      name = 'primary'
      break
    case 'disposal_completed':
      name = 'grey darken-3'
      break
    case 'receive_canceled':
      name = 'error'
      break
    default:
      name = ''
  }
  return name
})

Vue.filter('manifest_request_status_name', type => {
  let name
  switch (type) {
    case 'accepted':
      name = '受付済'
      break
    case 'rejected':
      name = '受付否決'
      break
    default:
      name = ''
  }
  return name
})

/**
 * 課税区分の文言を返す.
 * @return { string }
 */
Vue.filter('tax_type', role => {
  let tax_type = null
  switch (role) {
    case 'on_tax':
      tax_type = '課税'
      break
    case 'non_tax':
      tax_type = '非課税'
      break
  }
  return tax_type
})

/**
 * 品目区分の文言を返す.
 * @return { string }
 */
Vue.filter('sales_item_type', role => {
  let sales_item_type = null
  switch (role) {
    case 'jwnet_item':
      sales_item_type = '処理品目'
      break
    case 'cost_item':
      sales_item_type = '経費品目'
      break
    case 'purchase_item':
      sales_item_type = '仕入品目'
      break
  }
  return sales_item_type
})


/**
 * 売上品目種別の文言を返す.
 * @return { string }
 */
Vue.filter('sales_item_type_label', role => {
  let tax_type = null
  switch (role) {
    case 'processing':
      tax_type = '処理'
      break
    case 'sales':
      tax_type = '売上'
      break
  }
  return tax_type
})

/**
 * 現掛区分の文言を返す.
 * @return { string }
 */
Vue.filter('receivable_type_label', role => {
  let receivable_type = null
  switch (role) {
    case 'credit_transaction':
      receivable_type = '掛取引'
      break
    case 'cash_transaction':
      receivable_type = '現金取引'
      break
  }
  return receivable_type
})

/**
 * 請求支払区分の文言を返す.
 * @return { string }
 */
Vue.filter('billing_payment_type_label', role => {
  let billing_payment_type = null
  switch (role) {
    case 'billing_type':
      billing_payment_type = '請求'
      break
    case 'payment_type':
      billing_payment_type = '支払'
      break
  }
  return billing_payment_type
})

/**
 * 請求支払区分の状態カラーを返す.
 * @return {string}
 */
Vue.filter('billing_payment_type_color', (status) => {
  let color = null
  switch (status) {
    case 'billing_type':
      color = 'primary'
      break
    case 'payment_type':
      color = 'error'
      break
  }
  return color
})
